var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAssignedPin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_19194",
    "data-name": "Group 19194",
    xmlns: "http://www.w3.org/2000/svg",
    width: 33.22,
    height: 44.29,
    viewBox: "0 0 33.22 44.29",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-map-marker",
    "data-name": "Icon awesome-map-marker",
    d: "M14.9,43.4C2.333,25.175,0,23.305,0,16.609a16.61,16.61,0,0,1,33.22,0c0,6.7-2.333,8.567-14.9,26.788a2.077,2.077,0,0,1-3.414,0Z",
    transform: "translate(0)",
    fill: "#ababab"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Icon_ionic-md-home",
    "data-name": "Icon ionic-md-home",
    d: "M13.332,19.44V14.46H9.6v4.98H5.8V11.97H3.375l8.09-7.47,8.09,7.47H17.128v7.47Z",
    transform: "translate(5.145 2.705)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAssignedPin);
export default __webpack_public_path__ + "static/media/assigned-pin.7ca71eba3b8521f16b33e2286363c709.svg";
export { ForwardRef as ReactComponent };